export default (timeout = 0) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, timeout)
  })
